/**
 * management target pokemon status
 */
const state={
    id:null,//全国図鑑番号
    image_id:null,//PokeAPIの画像を利用するための番号
    name:null,//ポケモンの名前
    hp:10,//HP
    a:10,//攻撃
    b:10,//防御
    c:10,//特攻
    d:10,//特防
    s:10//素早さ
};

const getters={
    getId(state){
        return state.id;
    },
    getImageId(state){
        return state.image_id;
    },
    getName(state){
        return state.name;
    },
    getHP(state){
        return state.hp;
    },
    getA(state){
        return state.a;
    },
    getB(state){
        return state.b;
    },
    getC(state){
        return state.c;
    },
    getD(state){
        return state.d;
    },
    getS(state){
        return state.s;
    },
};

const mutations={
    /**
     * サーバ側から送られてきた対象ポケモンの種族値を登録
     * @param {this} state 
     * @param {JSON} {id,image_id,name,hp,a,b,c,d,s}
     */
    saveStatus(state,{id,image_id,name,hp,a,b,c,d,s}){
        state.id=id;
        state.image_id=image_id;
        state.name=name;
        state.hp=hp;
        state.a=a;
        state.b=b;
        state.c=c;
        state.d=d;
        state.s=s;
    },
    /**
     * 対象のポケモンをリセット
     * @param {this} state 
     */
    removeStatus(state){
        state.id=null;
        state.image_id=null;
        state.name=null;
        state.hp=10;
        state.a=10;
        state.b=10;
        state.c=10;
        state.d=10;
        state.s=10;
    },
};

const actions={
    saveStatus({commit},{id,image_id,name,hp,a,b,c,d,s}){
        commit("saveStatus",{id,image_id,name,hp,a,b,c,d,s});
    },
    removeStatus({commit}){
        commit("removeStatus");
    },
};

const targetPokemon={
    namespaced:true,//important
    state,
    getters,
    actions,
    mutations
};

export default targetPokemon;